import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Seo from '$components/Seo';
import styles from './styles.scss';

export default class NotFound extends Component {
  render() {
    const { linkText, linkTo } = this.props;

    return (
      <main className={styles.container}>
        <Seo
          title="Page not found"
          canonical={null}
          description={null}
          robots="noindex"
        />
        <section className={styles.section}>
          <div>Sorry, we couldn&apos;t find this page.</div>
          <h1 className={styles.glitch} data-text="404">
            404
          </h1>
          <div>
            <Link to={linkTo || '/'}>{linkText || 'Home'}</Link>
          </div>
        </section>
      </main>
    );
  }
}
